import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getThumbnailImage } from '../helpers';

import './PixleeWidgetItem.scss';

function PixleeWidgetItem ({
	item,
	updateModalProps,
	slideIndex = 0,
	className = '',
	isShopNowVisible = true,
	activeSlideIndex = null,
	carouselObj = null,
	slideToShowCount = 4,
	btnClassName = 'PixleeOutsideButtonGroup',
	imgAriaLabel = 'view customer image'
}) {

	const [ inHover, setHover ] = useState(false);

	const slidesToShow = carouselObj?.state?.slidesToShow;
	// activeSlideIndex used when PixleeWidgetItem is inside a carousel.
	// We use it to disable tabbing when it is off screen
	// Null means it's not in a carousel (like instagram page)
	const noTabbing =		activeSlideIndex !== null && (slideIndex < activeSlideIndex || slideIndex >= activeSlideIndex + slidesToShow);

	const mouseOver = (e, slideIndex) => {

		setHover(true);

		if (e.which === 9 && e.shiftKey === true && slideIndex % slideToShowCount === 0) {

			setTimeout(() => {

				const preArrow = document.querySelector(`.${btnClassName} .previousArrow`);
				preArrow.focus();

			}, 0);

		}

		if (e.which === 9 && e.shiftKey === false && slideIndex % slideToShowCount === slideToShowCount - 1) {

			setTimeout(() => {

				const nextArrow = document.querySelectorAll(`.${btnClassName} button`);
				nextArrow[nextArrow.length - 1].focus();

			}, 0);

		}

	};

	const mouseOut = () => {

		setHover(false);

	};

	const ovrlayClassName = classNames('carouselItemOverlay', className);
	const shopNowButtonElRef = useRef(null);

	return (
		<button
			className="PixleeWidgetItem"
			onClick={(e) => updateModalProps(item, slideIndex)({ shopNowButtonClicked: e.target === shopNowButtonElRef.current })}
			onMouseLeave={mouseOut}
			onBlur={mouseOut}
			onMouseOver={(e) => mouseOver(e, slideIndex, activeSlideIndex)}
			type="button"
			onKeyDown={(e) => mouseOver(e, slideIndex, activeSlideIndex)}
			tabIndex={noTabbing ? '-1' : undefined}
		>
			{inHover && (
				<div className={ovrlayClassName}>
					{isShopNowVisible && item.products.length ? (
						<span ref={shopNowButtonElRef} className="shopNowBtn" role="button">
							Shop Now
						</span>
					) : null}
				</div>
			)}
			<img
				src={getThumbnailImage(item)}
				alt=""
				aria-haspopup="true"
				aria-label={imgAriaLabel}
				data-index={slideIndex}
				tabIndex="-1"
				// TODO: Set height and width attributes depending on actual image data
				/*
					Currently aligned with 450, seen for square_medium_url,
				 	unknown for thumbnail_url and other sizes have been seen

					Some height/width needed for in-page anchor scroll issue, otherwise
					height of parent container isn't known until images are loaded
				*/
				height={item.content_type === 'image' && 450}
				width={item.content_type === 'image' && 450}
			/>
		</button>
	);

}

PixleeWidgetItem.propTypes = {
	item: PropTypes.objectOf(PropTypes.oneOfType([ PropTypes.any ])).isRequired,
	updateModalProps: PropTypes.func.isRequired,
	slideIndex: PropTypes.number.isRequired,
	className: PropTypes.string,
	isShopNowVisible: PropTypes.bool,
	activeSlideIndex: PropTypes.number,
	slideToShowCount: PropTypes.number,
	carouselObj: PropTypes.shape({
		state: PropTypes.shape({
			slidesToShow: PropTypes.number
		})
	})
};

export default PixleeWidgetItem;
